import { lazy } from 'react';
const ManualVoucherEf = lazy(() => import('./manuVoucherEf'));
const ManualVoucherEfNew = lazy(() => import('./manuVoucherEfNew'));

const manualVoucherEfRoutes = [
  {
    path: '/manuvouchef',
    component: ManualVoucherEfNew
  }
];

export default manualVoucherEfRoutes;